module.exports = __webpack_public_path__ + "img/banner-title-sm.34974c4d.png";